/* tslint:disable */ /* eslint-disable */
import * as Types from '../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type AddAutodiagnosticContactUserParticipationMutationVariables = Types.Exact<{
  input: Types.AutodiagnosticUserContactInput;
}>;


export type AddAutodiagnosticContactUserParticipationMutation = { addAutodiagnosticContactUserParticipation: boolean };


export const AddAutodiagnosticContactUserParticipationDocument = gql`
    mutation AddAutodiagnosticContactUserParticipation($input: AutodiagnosticUserContactInput!) {
  addAutodiagnosticContactUserParticipation(input: $input)
}
    `;
export type AddAutodiagnosticContactUserParticipationMutationResult = Apollo.MutationResult<AddAutodiagnosticContactUserParticipationMutation>;
export type AddAutodiagnosticContactUserParticipationMutationOptions = Apollo.BaseMutationOptions<AddAutodiagnosticContactUserParticipationMutation, AddAutodiagnosticContactUserParticipationMutationVariables>;